import ScrollToTopButton from "./ScrollToTopButton";
import WhatsappButton from "./WhatsappButton";

export default function FloatingActionShortcuts() {
	return (
		<div
			className="fixed bottom-0 2xl:bottom-[1.5vw] right-0 2xl:right-[1.5vw] z-50 p-4 flex flex-col justify-center items-center md:min-w-[80px] md:min-h-[128px]"
			role="group"
		>
			<ScrollToTopButton />
			<WhatsappButton />
		</div>
	);
}
